import React from 'react';
import './index.less';

import moment from 'moment';

import withIntl from '../../../../../../../shared/intl-hoc';

const PayoutDate = ({ intl, date }) => (
	<div className='payout-table--body--date'>
		{moment(date).format('DD.MM.YYYY')} {intl('at')} <span className='time'>{moment(date).format('HH:mm')}</span>
	</div>
);

export default withIntl(PayoutDate);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/components/payout-date/index.js